import styled from 'styled-components'

interface ExpenseTypeTileStyledProps {
  isActive: boolean
  isDisabled: boolean
}

export const ExpenseTypeTileStyled = styled.button<ExpenseTypeTileStyledProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${(props) => props.theme.typography.pxToRem(8)};
  width: ${(props) => props.theme.typography.pxToRem(72)};
  padding: 0;
  border: none;
  background: none;
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.isDisabled ? 0.5 : 1)};
`
